var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKompakt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "18px",
    viewBox: "0 0 22 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Kompakt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-368.000000, -2103.000000)",
    fill: "#464646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kompakt",
    transform: "translate(368.000000, 2103.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 0,
    y: 0,
    width: 22,
    height: 3.52,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    x: 0,
    y: 4.69333333,
    width: 22,
    height: 3.52,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    x: 0,
    y: 9.38666667,
    width: 22,
    height: 3.52,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    x: 0,
    y: 14.08,
    width: 22,
    height: 3.52,
    rx: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKompakt);
export default __webpack_public_path__ + "static/media/Kompakt.792eeabb35d3a338abcce31da1c79ad0.svg";
export { ForwardRef as ReactComponent };